import styled from 'styled-components';
import { gradients } from '../../theme/helpers';

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 10vh;
  width: 100vw;
  max-width: 100vw;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background: white;
  border-top: 1px solid lightgray;
  z-index: 9;
  a {
    display: flex;
    align-items: center;
  }

  p {
    margin: 1rem;
  }
`;

const MiddleButton = styled.button`
  background: ${gradients.gradientPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 5rem;
  height: 2.5rem;
  padding: 0.5rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  p {
    color: white;
  }
`;

export { MiddleButton };

export default Container;
